const ADD_NOTIFICATION = 'ADD_NOTIFICATION'
const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION'

// notification
// text
// type: error/success

export default {
  namespaced: true,
  state: {
    notifications: []
  },
  mutations: {
    [ADD_NOTIFICATION](state, notification) {
      state.notifications.push(notification)
    },
    [REMOVE_NOTIFICATION](state, notification) {
      state.notifications = state.notifications.filter(
        (item) => notification.text !== item.text
      )
    }
  },

  actions: {
    addNotification({ commit }, notification) {
      commit(ADD_NOTIFICATION, notification)
    },
    removeNotification({ commit }, notification) {
      commit(REMOVE_NOTIFICATION, notification)
    }
  }
}
